import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OptionalTripLocationsComponent } from '../optional-trip-locations.component';

export interface DialogData {
	locations: Array<any>;
	optionalTripLocations: [];
}
@Component({
	selector: 'app-optional-trip-location-add',
	templateUrl: './optional-trip-location-add.component.html',
	styleUrls: ['./optional-trip-location-add.component.css'],
})
export class OptionalTripLocationAddComponent {
	constructor(
		private readonly dialogRef: MatDialogRef<OptionalTripLocationAddComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DialogData,
	) {}

	onNoClick(): void {
		this.dialogRef.close();
	}
}
